import "core-js/modules/es.array.filter.js";
import moment from 'moment';

require('moment/locale/sl.js');

import { defineComponent, onMounted, onBeforeUnmount, ref, reactive, watch, computed } from 'vue';
export default defineComponent({
  props: {
    modelValue: {},
    startDate: {
      type: Date,
      default: function _default() {
        return moment().startOf('day').toDate();
      }
    },
    minDate: {
      type: Date,
      default: function _default() {
        return new Date(1900, 0, 1);
      }
    },
    maxDate: {
      type: Date,
      default: function _default() {
        return new Date(2099, 11, 31);
      }
    },
    format: {
      type: String,
      default: function _default() {
        return 'DD.MM.YYYY';
      }
    },
    showTime: {
      default: false
    },
    disabled: {
      default: false
    },
    readonly: {
      default: false
    },
    placeholder: {
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var input = ref();
    var root = ref();
    var state = reactive({
      currentView: 'days',
      viewTitle: '',
      itemsPerPage: 7,
      selectedDate: null,
      hour: '00',
      minute: '00',
      dayNames: ['PO', 'TO', 'SR', 'ČE', 'PE', 'SO', 'NE'],
      data: [{}],
      showCal: false
    });

    var formatDate = function formatDate(val, format) {
      return moment(val).format(format);
    };

    var blur = function blur() {
      var _input$value;

      var d = null;
      var m = moment((_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.value, props.format);

      if (!m.isValid()) {
        input.value.value = '';
      } else {
        d = m.toDate();

        if (m.isBefore(props.minDate) || m.isAfter(props.maxDate)) {
          d = null;
          input.value.value = '';
        }

        state.selectedDate = d;
      }

      if (!m.isSame(props.modelValue)) {
        if (!props.showTime) {
          state.showCal = false;
        }

        emit('update:modelValue', d);
      }
    };

    var showCaption = function showCaption(date) {
      var m = moment(date);
      return m.isSameOrAfter(props.minDate) && m.isSameOrBefore(props.maxDate);
    };

    var setDays = function setDays(date) {
      state.data = [];
      var firstDay = moment(date).startOf('month').startOf('isoWeek');
      var lastDay = moment(date).endOf('month').endOf('isoWeek');
      var day = firstDay;
      var i = 0;
      var today = moment().startOf('day');
      var currentMonth = moment(state.selectedDate);

      while (day <= lastDay) {
        var caption = showCaption(day.toDate()) ? formatDate(day.toDate(), 'D') : '';
        var d = day.toDate();

        if (props.showTime) {
          d.setHours(state.hour);
          d.setMinutes(state.minute);
        }

        state.data.push({
          index: i,
          date: d,
          today: today.isSame(day.startOf('day')),
          isGray: !currentMonth.isSame(day, 'month'),
          caption: caption
        });
        day = day.clone().add(1, 'd');
        i++;
      }
    };

    var setDecades = function setDecades(date) {
      state.data = [];
      var y = date.getFullYear();
      var s = Math.floor(y / 100) * 100 - 10;

      for (var i = 0; i < 12; i++) {
        var day = new Date(s + i * 10, 0, 1);
        var yy = day.getFullYear();

        if (y >= yy && y <= yy + 10) {
          state.selectedDate = day;
        }

        var caption = showCaption(day) ? yy + ' - ' + (yy + 9) : '';
        state.data.push({
          index: i,
          caption: caption,
          date: day
        });
      }
    };

    var setYears = function setYears(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }

      state.data = [];
      var y = date.getFullYear();
      state.selectedDate = new Date(y, 0, 1);
      var s = Math.floor(y / 10) * 10 - 1;

      for (var i = 0; i < 12; i++) {
        var day = new Date(s + i, 0, 1);
        var caption = showCaption(day) ? formatDate(day, 'YYYY') : '';
        state.data.push({
          index: i,
          caption: caption,
          date: day,
          isGray: i === 0 || i === 11
        });
      }
    };

    var setMonths = function setMonths(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }

      state.data = [];
      var y = date.getFullYear();
      var currentMonth = moment(date);

      for (var i = 0; i < 12; i++) {
        var day = new Date(y, i, 1);

        if (currentMonth.isSame(day, 'month')) {
          state.selectedDate = day;
        }

        var caption = showCaption(day) ? formatDate(day, 'MMM') : '';
        state.data.push({
          index: i,
          caption: caption,
          date: day
        });
      }
    };

    var setView = function setView() {
      if (!state.selectedDate && props.modelValue) {
        state.selectedDate = props.modelValue;
      }

      state.selectedDate = !state.selectedDate ? props.startDate : state.selectedDate;

      if (props.showTime) {
        state.hour = moment(state.selectedDate).format('HH');
        state.minute = moment(state.selectedDate).format('mm');
      }

      switch (state.currentView) {
        case 'days':
          {
            state.itemsPerPage = 7;
            state.viewTitle = formatDate(state.selectedDate, 'MMMM YYYY');
            setDays(state.selectedDate);
            break;
          }

        case 'months':
          {
            state.itemsPerPage = 4;
            state.viewTitle = formatDate(state.selectedDate, 'YYYY');
            setMonths(state.selectedDate);
            break;
          }

        case 'years':
          {
            state.itemsPerPage = 4;
            setYears(state.selectedDate);
            var d = state.data.filter(function (x) {
              return x.caption !== '';
            });
            state.viewTitle = d[0].caption + ' - ' + d[d.length - 1].caption;
            break;
          }

        case 'decades':
          {
            state.itemsPerPage = 4;
            setDecades(state.selectedDate);
            state.viewTitle = state.data.filter(function (x) {
              return x.date === state.selectedDate;
            })[0].caption;
            break;
          }
      }
    };

    var changeTime = function changeTime() {
      var m = moment(input.value.value, props.format);
      input.value.value = m.set({
        hour: state.hour,
        minute: state.minute
      }).format(props.format);
      setView();
      blur();
      state.showCal = true;
    };

    var showCalClick = function showCalClick() {
      if (props.disabled || props.readonly) {
        return;
      }

      state.showCal = !state.showCal;
    };

    var reset = function reset() {
      return state.showCal = false;
    };

    var isSelected = function isSelected(date) {
      return moment(state.selectedDate).startOf('day').isSame(moment(date).startOf('day'));
    };

    var getPrevNextDate = function getPrevNextDate(next) {
      switch (state.currentView) {
        case 'days':
          return moment(state.selectedDate).add(next ? 1 : -1, 'month').toDate();

        case 'months':
          return moment(state.selectedDate).add(next ? 1 : -1, 'year').toDate();

        case 'years':
          return moment(state.selectedDate).add(next ? 10 : -10, 'year').toDate();

        case 'decades':
          return moment(state.selectedDate).add(next ? 100 : -100, 'year').toDate();
      }
    };

    var switchView = function switchView() {
      switch (state.currentView) {
        case 'days':
          state.currentView = 'months';
          break;

        case 'months':
          state.currentView = 'years';
          break;

        case 'years':
          state.currentView = 'decades';
          break;

        case 'decades':
          return;
      }

      setView();
    };

    var moveNext = function moveNext(next) {
      state.selectedDate = getPrevNextDate(next);
      setView();
    };

    var dateClick = function dateClick(date) {
      var m = moment(date);

      if (m.isBefore(props.minDate) || m.isAfter(props.maxDate)) {
        return;
      }

      state.selectedDate = date;

      switch (state.currentView) {
        case 'days':
          input.value.focus();
          input.value.value = m.format(props.format);
          blur();
          break;

        case 'months':
          state.currentView = 'days';
          setView();
          break;

        case 'years':
          state.currentView = 'months';
          setView();
          break;

        case 'decades':
          state.currentView = 'years';
          setView();
          break;
      }
    };

    var dataByRows = function dataByRows(i) {
      return state.data.filter(function (x) {
        return x['index'] >= i * state.itemsPerPage && x['index'] < i * state.itemsPerPage + state.itemsPerPage;
      });
    };

    var leave = function leave(e) {
      if (root.value && !root.value.contains(e.target)) {
        state.showCal = false;
      }
    };

    watch(function () {
      return props.modelValue;
    }, function (val) {
      state.selectedDate = val;
      state.hour = '0';
      state.minute = '0';

      if (props.showTime && val) {
        state.hour = moment(val).format('HH');
        state.minute = moment(val).format('mm');
      }

      setView();
    });
    var canMovePrev = computed(function () {
      return moment(getPrevNextDate(false)).isSameOrAfter(props.minDate);
    });
    var canMoveNext = computed(function () {
      return moment(getPrevNextDate(true)).isSameOrBefore(props.maxDate);
    });
    var formattedValue = computed(function () {
      if (!props.modelValue) {
        return null;
      }

      var m = moment(props.modelValue);
      return m.isValid() ? m.format(props.format) : null;
    });
    onMounted(function () {
      setView();
      window.addEventListener('mousedown', leave);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('click', leave);
    });
    return {
      input: input,
      state: state,
      canMovePrev: canMovePrev,
      canMoveNext: canMoveNext,
      formattedValue: formattedValue,
      changeTime: changeTime,
      blur: blur,
      showCalClick: showCalClick,
      reset: reset,
      isSelected: isSelected,
      switchView: switchView,
      moveNext: moveNext,
      dateClick: dateClick,
      dataByRows: dataByRows,
      formatDate: formatDate,
      root: root
    };
  }
});